import React from 'react';

interface AuthLayoutProps {
  children: React.ReactNode;
  title: string;
  subtitle: string;
}

export default function AuthLayout({ children, title, subtitle }: AuthLayoutProps) {
  return (
    <div className="min-h-screen flex bg-white font-sans">
      {/* Left Side - Brand/Testimonial (Hidden on Mobile) */}
      <div className="hidden lg:flex lg:w-1/2 bg-brand-900 text-white flex-col justify-between p-12 relative overflow-hidden">
        {/* Abstract Background Element */}
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10 pointer-events-none">
          <div className="absolute -top-[20%] -right-[10%] w-[70%] h-[70%] rounded-full bg-white blur-3xl"></div>
        </div>

        <div className="relative z-10">
          <div className="flex items-center gap-2 mb-16">
             <div className="w-8 h-8 bg-white rounded-md flex items-center justify-center">
              <span className="text-brand-900 font-bold text-lg">F</span>
            </div>
            <span className="font-bold text-xl tracking-tight">FounderFinder</span>
          </div>

          <h1 className="text-4xl md:text-5xl font-bold leading-tight mb-6">
            Find leads that respond.<br/>
            Win more deals.
          </h1>
          <p className="text-brand-100 text-lg max-w-md">
            Join 40,000+ users accessing 280M truly verified leads and companies with unparalleled accuracy.
          </p>
        </div>

        <div className="relative z-10 bg-white/10 border border-white/20 p-6 rounded-2xl backdrop-blur-sm max-w-lg">
          <p className="text-white text-sm leading-relaxed mb-4">
            "We switched for the accuracy. We stayed for everything else. Director Discovery was the first platform where we didn't have to second-guess the data."
          </p>
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-brand-700 flex items-center justify-center font-bold text-sm">JW</div>
            <div>
              <p className="font-semibold text-sm">Josh Whitfield</p>
              <p className="text-brand-200 text-xs">Founder at CMM</p>
            </div>
          </div>
        </div>
      </div>

      {/* Right Side - Form Container */}
      <div className="w-full lg:w-1/2 flex items-center justify-center p-8 sm:p-12 lg:p-16">
        <div className="w-full max-w-md">
          {/* Mobile Logo (visible only on small screens) */}
          <div className="flex lg:hidden items-center gap-2 mb-8">
            <div className="w-8 h-8 bg-brand-900 rounded-md flex items-center justify-center">
              <span className="text-white font-bold text-lg">P</span>
            </div>
            <span className="font-bold text-xl tracking-tight text-slate-900">Director Discovery</span>
          </div>

          <div className="mb-8">
            <h2 className="text-3xl font-bold text-slate-900 mb-2">{title}</h2>
            <p className="text-slate-500">{subtitle}</p>
          </div>

          {children}
        </div>
      </div>
    </div>
  );
}